import { render, staticRenderFns } from "./loFooter.vue?vue&type=template&id=0a01d2cc&scoped=true&"
import script from "./loFooter.vue?vue&type=script&lang=js&"
export * from "./loFooter.vue?vue&type=script&lang=js&"
import style0 from "./loFooter.vue?vue&type=style&index=0&id=0a01d2cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a01d2cc",
  null
  
)

export default component.exports